import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { ErrorBoundary } from '@/components/ErrorBoundary';
import { App } from './App';
import { applyStoredTheme } from '@/stores/theme-store';

import './globals.css';
// Theme override blocks must come after globals.css so equal-specificity
// [data-theme] rules win over the base @theme/.dark tokens by order.
import './themes.css';

applyStoredTheme();

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('Missing #root element');
rootEl.dataset.version = `${__APP_VERSION__}+${__GIT_COMMIT_HASH__}`;
rootEl.dataset.buildTime = __BUILD_TIME__;

createRoot(rootEl).render(
  <StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </StrictMode>,
);
